<template>
  <button class="link-share-button" @click="click">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="currentColor"
    >
      <path
        d="M13.8033 1.41668C14.1804 1.57326 14.5228 1.80274 14.811 2.09196C15.3934 2.67227 15.7215 3.45999 15.7235 4.28211C15.7254 5.10422 15.401 5.89348 14.8214 6.47653L10.685 10.6129C10.3953 10.9029 10.0511 11.1327 9.67215 11.2889C9.2932 11.4451 8.88706 11.5246 8.47719 11.5229C7.65512 11.5277 6.86476 11.206 6.27973 10.6284C5.99051 10.3402 5.76103 9.99775 5.60445 9.62066C5.44787 9.24358 5.36727 8.83929 5.36727 8.43098C5.36727 8.02268 5.44787 7.61838 5.60445 7.2413C5.76103 6.86421 5.99051 6.52174 6.27973 6.23352L7.01394 5.49931L7.74298 6.23352L7.01394 6.96773C6.62586 7.35649 6.40811 7.8835 6.4086 8.43281C6.40908 8.98212 6.62776 9.50874 7.01652 9.89681C7.40529 10.2849 7.93229 10.5026 8.4816 10.5022C9.03091 10.5017 9.55753 10.283 9.94561 9.89423L14.082 5.75784C14.2745 5.56534 14.4272 5.33681 14.5314 5.08531C14.6355 4.8338 14.6892 4.56423 14.6892 4.292C14.6892 4.01977 14.6355 3.75021 14.5314 3.4987C14.4272 3.24719 14.2745 3.01866 14.082 2.82617C13.8895 2.63367 13.661 2.48097 13.4095 2.3768C13.158 2.27262 12.8884 2.219 12.6162 2.219C12.3439 2.219 12.0744 2.27262 11.8229 2.3768C11.5714 2.48097 11.3428 2.63367 11.1503 2.82617L10.4161 2.09196C10.7043 1.80274 11.0468 1.57326 11.4239 1.41668C11.801 1.2601 12.2053 1.1795 12.6136 1.1795C13.0219 1.1795 13.4262 1.2601 13.8033 1.41668ZM1.40292 10.7577C1.50746 11.0093 1.66067 11.2377 1.85374 11.4299C2.04591 11.623 2.27433 11.7762 2.52588 11.8807C2.77744 11.9852 3.04716 12.0391 3.31957 12.0391C3.59198 12.0391 3.86171 11.9852 4.11326 11.8807C4.36481 11.7762 4.59323 11.623 4.78541 11.4299L5.51962 12.1641C4.93107 12.7478 4.13553 13.0749 3.30665 13.0741C2.485 13.0844 1.69284 12.7683 1.10402 12.1951C0.814021 11.9068 0.583887 11.564 0.426848 11.1865C0.269809 10.8089 0.188965 10.404 0.188965 9.99508C0.188965 9.58615 0.269809 9.18127 0.426848 8.8037C0.583887 8.42613 0.814021 8.08334 1.10402 7.79503L5.24041 3.65864C5.8239 3.07515 6.61528 2.74735 7.44045 2.74735C8.26563 2.74735 9.05701 3.07515 9.6405 3.65864C10.224 4.24213 10.5518 5.0335 10.5518 5.85868C10.5518 6.68386 10.224 7.47524 9.6405 8.05873L8.54435 9.15487L7.81014 8.42066L8.90629 7.30901C9.09953 7.11556 9.25249 6.88573 9.35632 6.63279C9.46016 6.37985 9.51281 6.10883 9.51124 5.83541C9.51659 5.56285 9.46717 5.29198 9.36592 5.03886C9.26468 4.78574 9.11365 4.55551 8.9218 4.36182C8.72963 4.16875 8.50121 4.01555 8.24965 3.91101C7.9981 3.80647 7.72837 3.75266 7.45597 3.75266C7.18356 3.75266 6.91383 3.80647 6.66228 3.91101C6.41073 4.01555 6.1823 4.16875 5.99013 4.36182L1.85374 8.49822C1.66067 8.69039 1.50746 8.91881 1.40292 9.17037C1.29838 9.42192 1.24457 9.69164 1.24457 9.96405C1.24457 10.2365 1.29838 10.5062 1.40292 10.7577Z"
      />
    </svg>
  </button>
</template>

<script>
export default {
  name: "LinkShareButton",
  methods: {
    async click() {
      await navigator.clipboard.writeText(window.location.href);
      this.$emit("copied");
    }
  }
};
</script>

<style scoped lang="scss">
.link-share-button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  padding: 0;
  border-radius: 120px;
  color: var(--Core-Grayscale-800, #91918f);
  border: 1px solid var(--Core-Grayscale-800, #91918f);
  background: var(--Core-Grayscale-100, #fefefd);

  &:hover {
    color: var(--Core-Brand-Purple-Core-Brand-600, #442671);
    border: 1px solid var(--Core-Brand-Purple-Core-Brand-600, #442671);
  }
}
</style>
